import { useTutorialContext } from '../context/TutorialContext';

/**
 * Hook to access tutorial functionality
 * Provides a simplified interface to the TutorialContext
 */
export const useTutorial = () => {
  const context = useTutorialContext();

  return {
    // State
    isRunning: context.isRunning,
    isTutorialCompleted: context.isTutorialCompleted,
    isLoading: context.isLoading,

    // Actions
    startTutorial: context.startTutorial,
    stopTutorial: context.stopTutorial,
    completeTutorial: context.completeTutorial,
    resetTutorial: context.resetTutorial,
  };
};

export default useTutorial;
